import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import _ from 'lodash';

import Order from './additionalInfo/Order';
import InquireQuotation from './additionalInfo/InquireQuotation';
import ContactDealer from './additionalInfo/ContactDealer';
import ImageContainer from '../image-handler/ImageContainer';
import {fetchDataApi} from '../../api/fetchData';
import {URL, URL_PDF} from '../../config/Config';
import Cookies from 'universal-cookie';
import {PulseLoader} from 'react-spinners';
import Skeleton from 'react-loading-skeleton';

import {
    setRequiredDataFormat, setSwitchValue, deleteUnnecessaryFields, initialClean,
    setInverterValue
} from '../../utils/prepareData';
import {
    mmCodes,
    dwdFieldsToDelete,
    fieldsToDelete,
    wtFieldsToDelete,
    krwFieldsToDelete,
    metricConversion,
    convertStringToNumber,
    parseNumberToString
} from '../../utils/helpers';
import {Maybe, logging} from '../../utils/logging';
import {setLanguageIndex} from '../../utils/helpers';

class Download extends Component {

    /**
     * initialize contructor
     */
    constructor(props) {
        super(props);

        // check partner Mode
        const cookies = new Cookies();
        let showPrices = cookies.get('smloc');
        let partnerMode = (showPrices !== 'true');

        this.state = {
            // TODO hardcoded currently
            price: '',
            additionalInfo: 'inquireQuotation',
            dxf: this.props.image.DXF,
            pdf: '',
            fullBaseArticle: '',
            sgvsbNo: '',
            stNo: '',
            configurationCode: '',
            partnerMode: partnerMode
        }
    }

    /**
     * lifecycle componenntDidMount
     */
    componentDidMount() {
        // TODO - move const to other file
        const bathtubSwitches = ['Z23', 'Z45', 'Z67', 'Z81'];
        const krwSwitches = ['SK23', 'SK45', 'SK67', 'SK81'];
        const dwdfSwitches = ['Z23', 'Z45', 'Z67', 'Z81', 'S23', 'S45', 'S67', 'S81'];
        const wtInverters = ['UL'];
        let dataForSending;
        console.log("Download:", this.props);
        if (this.props.article === 'dwdf') {
            dataForSending = setSwitchValue(this.props.dwdf, dwdfSwitches);
        } else if (this.props.article === 'bathtub') {
            dataForSending = setSwitchValue(this.props.bathtub, bathtubSwitches);
        } else if (this.props.article === 'krw') {
            dataForSending = setSwitchValue(this.props.krw, krwSwitches);
        }  else {
            dataForSending = setInverterValue(this.props.wt, wtInverters);
        }
        dataForSending = setRequiredDataFormat(dataForSending);
        // transform from cm to mm
        mmCodes.forEach((code) => {
            if (dataForSending[code]) {
                const currentValue = convertStringToNumber(dataForSending[code]);
                dataForSending[code] = metricConversion(currentValue, 'cm', 'mm').toString();
            }
        });
        dataForSending = initialClean(dataForSending, ['-']);
        if (this.props.article === 'dwdf') {
            dataForSending = deleteUnnecessaryFields(dataForSending, dwdFieldsToDelete);
        } else if (this.props.article === 'wt') {
            dataForSending = deleteUnnecessaryFields(dataForSending, wtFieldsToDelete);
        } else if (this.props.article === 'krw') {
            dataForSending = deleteUnnecessaryFields(dataForSending, krwFieldsToDelete);
        } else {
            dataForSending = deleteUnnecessaryFields(dataForSending, fieldsToDelete);
        }

        // change GT to string
        Maybe.of(parseNumberToString(dataForSending.GT)._value)
                .map((value) => {
                    dataForSending.GT = value;
                })

        // change OT to string
        Maybe.of(parseNumberToString(dataForSending.OV)._value)
                .map((value) => {
                    dataForSending.OV = value;
                })

        // fix whirlconfig
        Maybe.of(dataForSending.WS)
            .map((ws) => {
                if(ws.CurrentValue !== "00") {
                    dataForSending.WSTP = "23";
                    dataForSending.WZP = "06";
                    dataForSending.ES = "67";
                }
        });

        // set data for price POST
        const requestPrice = {
            BaseArticle: this.props.articleID,
            Features: dataForSending,
            Pricing: 'true'
        }

        // set data for CustomerProposal POST
        const customerProposalRequest = {
            BaseArticle: this.props.articleID,
            Features: dataForSending,
            CustomerProposal: 'true'
        }

        // prepare object for sending
        this.props.fetchImage(this.props[this.props.article], this.props.article, this.props.articleID, 'DXF')
                .then((iresult) => {
                    this.setState({
                        dxf: iresult.DXF,
                        sgvsbNo: iresult.SgvsbNo ? iresult.SgvsbNo : '-',
                        stNo: iresult.StNo ? iresult.StNo : '-'
                    });

                    if(this.state.partnerMode !== true) {
                        fetchDataApi(`${URL}data`, 'POST', requestPrice)
                                .then((presult) => {
                                    this.setState({
                                        price: presult.NetPrice,
                                    });

                                    this.storeConfiguration(customerProposalRequest, presult);

                                })
                                .catch((err) => {
                                    console.error(err);
                                });
                    } else {
                        this.storeConfiguration(customerProposalRequest, { NetPrice: '-.--' });
                    }

                })
                .catch((err) => {
                    console.error(err);
                });

    }

    componentWillUnmount() {
        this.setState = (state,callback)=>{
            return;
        };
    }

    /**
     * fetch PDF
     */
    storeConfiguration(customerProposalRequest, priceData) {
        fetchDataApi(`${URL}data`, 'POST', customerProposalRequest)
                .then((result) => {
                    this.setState({
                        configurationCode: result.CustomerProposalId,
                    });


                    let specs = [];
                    if (document.getElementById("summaryFull") && document.getElementById("summaryFull").hasChildNodes()) {
                        const children = document.getElementById("summaryFull").childNodes;
                        for (let i = 0; i < children.length; i++) {
                            let text = children[i].textContent;
                            if (!(text === undefined || text === '')) {
                                specs.push(children[i].textContent);
                            }
                        }
                        specs.push('');
                        specs.push('');
                        specs.push('');
                    }

                    const requestPdf = {
                        locale: this.props.currentLanguage,
                        imagePath: this.props.image.Image,
                        productName: this.props[this.props.article].MODEL,
                        configurationCode: result.CustomerProposalId,
                        specs: specs,
                        price: priceData.NetPrice,
                        productNumber: this.props.articleID,
                        serialNumber: this.props[this.props.article].STNO,
                        sgvsbNumber: this.props[this.props.article].SGVSBNO
                    };

                    fetchDataApi(URL_PDF, 'POST', requestPdf)
                            .then((pdfObject) => {
                                this.setState({
                                    pdf: pdfObject.pdf,
                                });
                            })
                            .catch((err) => {
                                console.error(err);
                            });

                })
                .catch((err) => {
                    console.error(err);
                });
    }


    /**
     * show additional info about configured product
     * @param {String} field
     */
    showAdditionalInfo(field) {
        this.setState({
            additionalInfo: field,
        });
    }

    /**
     * render addtional info field
     * @param {String} field
     * @returns {Func} Functional component
     */
    renderAdditionalInfo(field) {
        switch (field) {

            case 'order':
                return <Order/>;
            case 'inquireQuotation':
                return <InquireQuotation article={this.props.article}/>;
            case 'contactDealer':
                return <ContactDealer/>;
            default:
                return <Order/>;

        }
    }

    /**
     * render statistic info of product
     * @param {String} title
     * @param {Number} number
     * @returns template
     */
    renderStatisticInfo(title, number, loader) {
        return (
                <div className='row'>
                    <div className='title'>{title}</div>
                    <div>{loader ? <Skeleton /> :  number}</div>
                </div>
        )
    }

    printPage(icon) {
        if (icon === 'icon--print') {
            return window.print();
        }
    }

    /**
     * render icon template
     * @param {String} classes of parent div
     * @param {String} icon type
     * @returns template
     */
    renderIcon(icon) {
        const styleForLoading = icon === 'icon--pdf' ? this.state.pdf ? '' : 'loading-parts ' : '';
        return (
                <span className={`icon-holder ${styleForLoading}`} >
                <button className='btn btn-flat'>
                    {icon === 'icon--dxf' ? this.state.dxf ?
                            <a href={this.state.dxf} download>
                                <span className={icon}></span>
                            </a>
                        : null
                            : icon === 'icon--pdf' ?
                                    this.state.pdf  ?
                                        <a href={this.state.pdf} target="_blank" download>
                                            <span className={icon}></span>
                                        </a>
                                        :   null
                                            : <span className={icon} onClick={this.printPage.bind(this, icon)}></span>
                    }
                </button>
            </span>
        );
    }

    renderPriceInfo() {
        return (
            <div className='row'>
                <div className='title'>{this.props.translate('downloadAndContact.recommended')}</div>
                <div className='title'>{this.props.translate('downloadAndContact.salesPrice')}</div>
                <h4 className='price'>{this.state.price ? this.state.price : <Skeleton />}</h4>
            </div>
        );
    }

    showSpinner() {
        return (
            <div className='align-center sweet-loading d-spinner-c'>
                <PulseLoader
                    color={'#003B71'}
                    loading={true}
                />
            </div>
        );
    }

    /**
     * render template
     */
    render() {
        return (
                <div className='download-contact step-content'>
                    <div className='top-container'>
                        <div className='row' style={{marginBottom: 0}}>
                            <div className='col s3'>
                                {this.renderStatisticInfo(
                                        this.props.translate('downloadAndContact.configurationCode'),
                                        `${this.state.configurationCode}`,
                                                !this.state.configurationCode
                                )
                                }
                                {this.renderStatisticInfo(
                                        this.props.translate('downloadAndContact.schmidlinArtNo'),
                                        `${this.props.articleID}`
                                )}
                                {this.renderStatisticInfo(
                                    this.props.translate('downloadAndContact.SGNr'),
                                    `${this.state.sgvsbNo}`,
                                            !this.state.sgvsbNo
                                    )
                                }

                                {this.renderStatisticInfo(
                                    this.props.translate('downloadAndContact.stNr'),
                                    `${this.state.stNo}`,
                                            !this.state.stNo
                                )
                                }
                            </div>
                            <div className='col s6'>
                                <ImageContainer image={this.props.image.Image} alt={this.props.name}/>
                            </div>
                            <div className='col s3'>
                                { this.state.partnerMode !== true ? this.renderPriceInfo() : '' }
                                <div className="row title">
                                    Downloads:
                                </div>
                                <div className='row row--flex download-icons-c'>
                                    {this.state.pdf && this.state.dxf ? null : this.showSpinner()}
                                    {this.renderIcon('icon--pdf')}
                                    {this.renderIcon('icon--dxf')}
                                </div>
                                <div className='row'>
                                    {this.renderIcon('icon--print')}
                                    {/*this.renderIcon('icon--share') */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='bottom-container'>
                        <div className={`col s12 ${this.state.additionalInfo === 'inquireQuotation' ? 'selected-field' : ''}`}>
                            <h5
                                    className='center-align'
                                    onClick={this.showAdditionalInfo.bind(this, 'inquireQuotation')}>
                                {this.props.translate('downloadAndContact.inquireQuotation')}
                            </h5>
                        </div>
                        {/*<div
                        className={`col m4 ${this.state.additionalInfo === 'order' ? 'selected-field' : ''}`}>
                        <h5
                            className='center-align'
                            onClick={this.showAdditionalInfo.bind(this, 'order')}>
                            {this.props.translate('downloadAndContact.order')}
                        </h5>
                        </div>
                        <div
                                className={`col m6 ${this.state.additionalInfo === 'contactDealer' ? 'selected-field' : ''}`}>
                            <h5
                                    className='center-align'
                                    onClick={this.showAdditionalInfo.bind(this, 'contactDealer')}>
                                {this.props.translate('downloadAndContact.contactDealer')}
                            </h5>
                        </div>*/}
                        <div
                                className='col s12 additional-info'>
                            {this.state.additionalInfo ?
                                this.renderAdditionalInfo(this.state.additionalInfo)
                            : <Skeleton />
                            }
                        </div>
                    </div>
                </div>
        );
    }

}

/**
 * define prop types
 */
Download.propTypes = {
    translate: PropTypes.func,
    lastStep: PropTypes.number,
    currentStep: PropTypes.number,
    bathtub: PropTypes.object,
    articleID: PropTypes.string,
    image: PropTypes.object,
    name: PropTypes.string,
    article: PropTypes.string,
    currentLanguage: PropTypes.string,
}

/**
 * mapStateToProps
 * @param {Object} state
 * @returns {Object} {translate, currentLanguge}
 */
function mapStateToProps(state) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        bathtub: state.bathtub,
        dwdf: state.dwdf,
        wt: state.wt,
        image: state.image,
        krw: state.krw,
        articleID: state.articleID,
        partnerMode: state.partnerMode,
    };
}

export default connect(mapStateToProps, actions)(Download);



// WEBPACK FOOTER //
// ./src/components/download/Download.js